(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["KI-Sommelier"] && !Shopify.designMode) return;
  try {
    
/* No JS changes required for styling. */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Produktvorschau"] && !Shopify.designMode) return;
  try {
    
/* Keine JS-Logik erforderlich; Links sind klickbar auf Bild & Titel. */

  } catch(e) { console.error(e); }
})();
})();
